import { useState } from 'react';
import { InventoryCell, InventoryType as InventoryCellType } from '~/shared';

export const useInventoryDrag = () => {
	const [dragging, setDragging] = useState(false);
	const [draggedItem, setDraggedItem] = useState<{
		cell: InventoryCell;
		sourceType: InventoryCellType;
	} | null>(null);

	const handleDragStart = (
		e: React.DragEvent,
		cell: InventoryCell,
		sourceType: InventoryCellType,
	) => {
		if (!cell.item) {
			e.preventDefault();
			return;
		}
		setDragging(true);
		setDraggedItem({ cell, sourceType });
		e.dataTransfer.effectAllowed = 'move';
	};

	const handleDragOver = (e: React.DragEvent) => {
		e.preventDefault();
		e.dataTransfer.dropEffect = 'move';
		setDragging(true);
	};

	const handleDragEnd = () => {
		setDraggedItem(null);
		setDragging(false);
	};

	return {
		dragging,
		draggedItem,
		handleDragStart,
		handleDragOver,
		handleDragEnd,
	};
};
